"use strict";
export function assume0xAddress(address) {
  return address;
}
